import { AppUserFullInfo, UserTypes } from '../../userinfo/types';

export const checkPepFailedStatus = (userData: AppUserFullInfo): boolean => {
  const { userType, pepStatus, tradingActive, active } = userData;

  if (userType === UserTypes.BUSINESS_USER) return false;

  if (pepStatus === 'NONE' && !tradingActive && active) return true;

  if (pepStatus === 'FAILED' && !tradingActive) return true;

  if (pepStatus === 'SUCCESS' && !tradingActive && active) return true;

  return false;
};
